import { NameMatch } from '../translations-types';

const translations: NameMatch = {
  title: 'Klantnaam vergelijken',
  description:
    'Upload een CSV met e-mailadres en naam. De lijst wordt op e-mailadres afgezet tegen je Re-sence-cliënten; afwijkende namen kun je met één klik overnemen.',
  selectFile: 'CSV kiezen',
  loadingCustomers: 'Cliënten laden…',
  summary: 'Samenvatting',
  discrepancies: 'Afwijkingen',
  notFound: 'Niet gevonden',
  identical: 'Gelijk',
  email: 'E-mail',
  currentName: 'Huidige naam',
  newName: 'Nieuwe naam (CSV)',
  apply: 'Overnemen',
  applyError: 'Mislukt',
  status: 'Status',
  noDiscrepancies: 'Geen afwijkingen gevonden.',
  parseError: 'Kan het CSV-bestand niet lezen.',
  emptyFile: 'Het bestand bevat geen regels.',
  missingColumns: 'De CSV mist een e-mail- of naamkolom.',
  notFoundHint: 'Deze e-mailadressen uit de CSV komen niet voor in Re-sence.',
};

export default translations;
